var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currentLocation"},[_vm._v("您当前所在位置 > "+_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }